var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-default-view",class:{'collapsed-side-nav': _vm.collapseSideNav}},[_c('SideNav',{attrs:{"collapsed":_vm.collapseSideNav},on:{"onExpand":function($event){_vm.collapseSideNav = false},"onCollapse":function($event){_vm.collapseSideNav = true}}}),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }